<template>
    <div>
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon"
                                                         :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)">
                    </van-col>
                    <van-col span="12">
                        <div class="banner-title">{{ $t('trainingStatus.title') }}</div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="content">
            <div class="time-box">
                <div class="time-item" :class="{'time-active': activeTime === 0}" @click="changeTimeType(0, $t('dailyActive.time0'))">{{ $t('dailyActive.time0') }}</div>
                <div class="time-item" :class="{'time-active': activeTime === 1}" @click="changeTimeType(1, $t('dailyActive.time1'))">{{ $t('dailyActive.time1') }}</div>
            </div>
            <div class="time-select">
                <img @click="timeLeft" class="time-icon" :class="{'arr-opacity' : showLeftOpacity == 1}"
                     :src="require(`@/assets/theme/${theme}/status/01dailyActive/03left.svg`)">
                <div class="time-date">{{time}}</div>
                <img @click="timeRight" class="time-icon" :class="{'arr-opacity' : showRightOpacity == 1}"
                     :src="require(`@/assets/theme/${theme}/status/01dailyActive/04right.svg`)">
            </div>
            <div id="chart-box"></div>
            <div class="legend-box" v-if="$i18n.locale == 'zh'">
                <div class="legend-bar1 legend-bar"></div>
                <div class="legend-bar2 legend-bar"></div>
                <div class="legend-bar3 legend-bar"></div>
                <div class="legend-bar4 legend-bar"></div>
                <div class="legend-bar5 legend-bar"></div>
                <div class="legend-bar6 legend-bar"></div>
                <div class="legend-bar7 legend-bar"></div>
                <div class="legend-bar8 legend-bar"></div>
                <div class="legend-text1 legend-text"> {{$t('trainingStatus.level0')}}</div>
                <div class="legend-text2 legend-text"> {{$t('trainingStatus.level1')}}</div>
                <div class="legend-text3 legend-text"> {{$t('trainingStatus.level2')}}</div>
                <div class="legend-text4 legend-text"> {{$t('trainingStatus.level3')}}</div>
                <div class="legend-text5 legend-text"> {{$t('trainingStatus.level4')}}</div>
                <div class="legend-text6 legend-text"> {{$t('trainingStatus.level5')}}</div>
                <div class="legend-text7 legend-text"> {{$t('trainingStatus.level6')}}</div>
                <div class="legend-text8 legend-text"> {{$t('trainingStatus.level7')}}</div>
            </div>
            <div class="legend-box-en" v-if="$i18n.locale == 'en'">
                <div class="legend-bar11 legend-bar"></div>
                <div class="legend-bar22 legend-bar"></div>
                <div class="legend-bar33 legend-bar"></div>
                <div class="legend-bar44 legend-bar"></div>
                <div class="legend-bar55 legend-bar"></div>
                <div class="legend-bar66 legend-bar"></div>
                <div class="legend-bar77 legend-bar"></div>
                <div class="legend-bar88 legend-bar"></div>
                <div class="legend-text11 legend-text"> {{$t('trainingStatus.level0')}}</div>
                <div class="legend-text22 legend-text"> {{$t('trainingStatus.level1')}}</div>
                <div class="legend-text33 legend-text"> {{$t('trainingStatus.level2')}}</div>
                <div class="legend-text44 legend-text"> {{$t('trainingStatus.level3')}}</div>
                <div class="legend-text55 legend-text"> {{$t('trainingStatus.level4')}}</div>
                <div class="legend-text66 legend-text"> {{$t('trainingStatus.level5')}}</div>
                <div class="legend-text77 legend-text"> {{$t('trainingStatus.level6')}}</div>
                <div class="legend-text88 legend-text"> {{$t('trainingStatus.level7')}}</div>
            </div>
        </div>
<!--        <div class="math-box">-->
<!--            <div class="math-title">【{{selectStatus}}】</div>-->
<!--            <div class="math-info">{{getTrainingStatusDesc(selectStatus)}}</div>-->
<!--        </div>-->
        <div class="desc-box">
            <div class="desc-title">{{$t('trainingStatus.descTitle')}}</div>
            <div class="desc-info desc-last">
                {{$t('trainingStatus.desc0')}}
                <br>
                {{$t('trainingStatus.desc1')}}
                <br>
                {{$t('trainingStatus.desc2')}}
                <br>
                {{$t('trainingStatus.desc3')}}
                <br>
                {{$t('trainingStatus.desc4')}}
                <br>
                {{$t('trainingStatus.desc5')}}
                <br>
                {{$t('trainingStatus.desc6')}}
                <br>
                {{$t('trainingStatus.desc7')}}
                <br>
                {{$t('trainingStatus.desc8')}}
            </div>
        </div>
    </div>
</template>

<script>
    import {getQueryVariable, getSkin} from '@/utils/comment'
    import {
        getToday,
        getNWeekFirstDay,
        getNWeekLastDay,
        getMonthStartDay,
        getMonthEndDay,
        GetDateStr, SwitchTime24,
        changeDate,
        changeMonthDate,
        GetYear
    } from "../../utils/dateUtils";
    import {WebJSBridge} from "../../utils/JSBridge1";

    export default {
        name: 'trainingStatus',
        data() {
            return {
                ratio: 1,
                theme: getQueryVariable("theme") ? getQueryVariable("theme") : "light",
                timeUnit: '',
                activeTime: 0,
                time: '',
                startDate: '',
                endDate: '',
                wNum: 0,
                mNum: 0,
                showTimeBox: false,
                info: {},
                mathData: {},
                myChart: null,
                showLeftOpacity: 0,
                showRightOpacity: 1,
                selectStatus: ''
            }
        },
        watch: {
            showTimeBox: {
                handler(newVal, olVal) {
                    if (newVal) {
                        setTimeout(() => {
                            document.addEventListener('click', this.checkClick);
                        }, 0);
                    } else {
                        document.removeEventListener('click', this.checkClick);
                    }
                }
            }
        },
        mounted() {
            this.ratio = document.body.clientWidth / 375 ? document.body.clientWidth / 375 : 1;
            this.timeUnit = this.$t('trainingStatus.time0');
            this.startDate = getNWeekFirstDay(this.wNum);
            this.endDate = getNWeekLastDay(this.wNum);
            this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
            this.getData();
        },
        methods: {
            back() {
                WebJSBridge.call("closeWeb", null, function (res) {
                });
            },
            checkClick(event) {
                let dom = this.$refs.showContent; // 这里是你的下拉菜单元素
                if (!dom.contains(event.target)) {
                    // 不在菜单范围，隐藏即可
                    if (this.showTimeBox) {
                        this.showTimeBox = false;
                        document.removeEventListener('click', this.checkClick);
                    }
                }
            },
            checkOpacity() {
                if (this.activeTime == 0 && this.wNum >= 0) {
                    this.showRightOpacity = 1
                } else if (this.activeTime == 1 && this.mNum >= 0) {
                    this.showRightOpacity = 1
                } else {
                    this.showRightOpacity = 0
                }
                if (this.activeTime == 0 && this.startDate <= '2020-01-01') {
                    this.showLeftOpacity = 1
                } else if (this.activeTime == 1 && this.startDate <= '2020-01-01') {
                    this.showLeftOpacity = 1
                } else {
                    this.showLeftOpacity = 0
                }
            },
            timeLeft() {
                if (this.activeTime == 0 && this.startDate > '2020-01-01') {
                    this.wNum--;
                    this.startDate = getNWeekFirstDay(this.wNum);
                    this.endDate = getNWeekLastDay(this.wNum);
                    this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
                } else if (this.activeTime == 1 && this.startDate > '2020-01-01') {
                    this.mNum--;
                    this.startDate = getMonthStartDay(this.mNum);
                    this.endDate = getMonthEndDay(this.mNum);
                    this.time = changeMonthDate(this.startDate);
                }
                this.getData();
            },
            timeRight() {
                if (this.activeTime == 0 && this.wNum < 0) {
                    this.wNum++;
                    this.startDate = getNWeekFirstDay(this.wNum);
                    this.endDate = getNWeekLastDay(this.wNum);
                    this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
                } else if (this.activeTime == 1 && this.mNum < 0) {
                    this.mNum++;
                    this.startDate = getMonthStartDay(this.mNum);
                    this.endDate = getMonthEndDay(this.mNum);
                    this.time = changeMonthDate(this.startDate);
                }
                this.getData();
            },
            changeTimeType(num, unit) {
                this.activeTime = num;
                this.timeUnit = unit;
                this.showTimeBox = false;
                if (this.activeTime == 0) {
                    this.startDate = getNWeekFirstDay(this.wNum);
                    this.endDate = getNWeekLastDay(this.wNum);
                    this.time = this.startDate.slice(5, 10).replace(/-/g, '/') + ' - ' + this.endDate.slice(5, 10).replace(/-/g, '/');
                }
                if (this.activeTime == 1) {
                    this.startDate = getMonthStartDay(this.mNum);
                    this.endDate = getMonthEndDay(this.mNum);
                    this.time = changeMonthDate(this.startDate);
                }
                this.getData();
            },
            getData() {
                this.checkOpacity();
                this.$api.status.queryTrainingStatus({
                    startDate: this.startDate,
                    endDate: this.endDate
                }).then(res => {
                    if (res.result == 1) {
                        this.info = res.info;
                        this.info.dateArr = [];
                        this.info.dataArr = [];
                        this.info.dataStatusArr = [];
                        for (let i = 0; i < this.info.data.length; i++) {
                            this.info.dateArr.push(this.info.data[i].date);
                            let color;
                            let data = this.info.data[i].trainingStatus ? this.info.data[i].trainingStatus : 0;
                            color = this.getStatusColor(data)[0];
                            this.info.dataStatusArr.push(this.getStatusColor(data)[1])
                            let style = {
                                value: 5,
                                itemStyle: {
                                    color: color,
                                    borderRadius: [5, 5, 5, 5],
                                },
                                emphasis: {
                                    itemStyle: {
                                        opacity: 0.5,
                                    }
                                }
                            }
                            this.info.dataArr.push(style);
                        }
                        this.selectStatus = this.info.dataStatusArr[this.info.dataStatusArr.length - 1]
                        this.$nextTick(function () {
                            this.drawChart()
                            this.$forceUpdate()
                        })
                    }
                })
            },
            getStatusColor(num) {
                let color;
                let r;
                if (num == 0) {
                    color = '#B8C3D4';
                    r = this.$t('trainingStatus.level0');
                } else if (num == 1) {
                    color = '#2A6BEE';
                    r = this.$t('trainingStatus.level1');
                } else if (num == 2) {
                    color = '#30CBEB';
                    r = this.$t('trainingStatus.level2');
                } else if (num == 3) {
                    color = '#00BD9B';
                    r = this.$t('trainingStatus.level3');
                } else if (num == 4) {
                    color = '#F1DB1B';
                    r = this.$t('trainingStatus.level4');
                } else if (num == 5) {
                    color = '#FF7347';
                    r = this.$t('trainingStatus.level5');
                } else if (num == 6) {
                    color = '#EB6A65';
                    r = this.$t('trainingStatus.level6');
                } else if (num == 7) {
                    color = '#FF0101';
                    r = this.$t('trainingStatus.level7');
                }
                return [color, r];
            },
            drawChart() {
                if (!this.myChart) {
                    this.myChart = this.$echarts.init(document.getElementById("chart-box"));
                }
                let barWidth = 10 * this.ratio;
                if (this.activeTime == 1) {
                    barWidth = 4 * this.ratio;
                } else {
                    barWidth = 10 * this.ratio;
                }
                let _this = this;
                this.myChart.setOption({
                    grid: {
                        top: 35 * this.ratio,
                        bottom: 37 * this.ratio,
                        left: 28 * this.ratio,
                        right: 35 * this.ratio
                    },
                    dataZoom: { // 放大和缩放
                        type: 'inside'
                    },
                    tooltip: {
                        backgroundColor: getSkin('--bg-color-2'),
                        trigger: 'axis',
                        position: (point, params, dom, rect, size) => {
                            let x = point[0]-size.contentSize[0]/2;
                            let cWidth = 375 * _this.ratio;
                            if (x < 0) {
                                x = 0;
                            } else if ((x + size.contentSize[0]) > cWidth ) {
                                x =  cWidth - size.contentSize[0];
                            }
                            return [x, '0%'];
                        },
                        formatter: function (params, ticket, callback) {
                            let item = params[0];
                            let value = item.value ? item.value : 0;
                            if (value == 0) {
                                return
                            }
                            _this.selectStatus = _this.info.dataStatusArr[item.dataIndex];
                            let status = _this.info.dataStatusArr[item.dataIndex];
                            let html = '';
                            html += '<div style="font-family:D-D;font-size:13px;color: ' + getSkin('--text-color-3') + '">' + changeDate(item.axisValue) + '</div>'
                            html += '<div style="font-size:13px;color: ' + getSkin('--text-color-3') + '"><span style="font-size:20px;font-family:SF;color: ' + getSkin('--text-color-1') + '">' + status + '</span></div>'
                            return html
                        }
                    },
                    xAxis: {
                        type: 'category',
                        axisLine: {
                            lineStyle: {
                                color: getSkin('--line-color-2')
                            }
                        },
                        axisLabel: {
                            fontSize: 11 * this.ratio,
                            fontFamily: 'D-D',
                            color: getSkin('--text-color-3'),
                            formatter: function (value) {
                                return changeDate(value)
                            }
                        },
                        axisTick: {
                            show: false
                        },
                        data: this.info.dateArr
                    },
                    yAxis: {
                        type: 'value',
                        position: 'left',
                        splitLine: false,
                        axisLabel: false
                    },
                    series: [
                        {
                            data: this.info.dataArr,
                            type: 'bar',
                            barWidth: barWidth
                        }
                    ]
                }, true);
            },
            getTrainingStatus(n) {
                if (n == 0) {
                    return '【' + this.$t('trainingStatus.level0') + '】'
                } else if (n == 1) {
                    return '【' + this.$t('trainingStatus.level1') + '】'
                } else if (n == 2) {
                    return '【' + this.$t('trainingStatus.level2') + '】'
                } else if (n == 3) {
                    return '【' + this.$t('trainingStatus.level3') + '】'
                } else if (n == 4) {
                    return '【' + this.$t('trainingStatus.level4') + '】'
                } else if (n == 5) {
                    return '【' + this.$t('trainingStatus.level5') + '】'
                } else if (n == 6) {
                    return '【' + this.$t('trainingStatus.level6') + '】'
                } else if (n == 7) {
                    return '【' + this.$t('trainingStatus.level7') + '】'
                }
            },
            getTrainingStatusDesc(n) {
                if (n == this.$t('trainingStatus.level0')) {
                    return this.$t('trainingStatus.desc1')
                } else if (n == this.$t('trainingStatus.level1')) {
                    return this.$t('trainingStatus.desc2')
                } else if (n == this.$t('trainingStatus.level2')) {
                    return this.$t('trainingStatus.desc3')
                } else if (n == this.$t('trainingStatus.level3')) {
                    return this.$t('trainingStatus.desc4')
                } else if (n == this.$t('trainingStatus.level4')) {
                    return this.$t('trainingStatus.desc5')
                } else if (n == this.$t('trainingStatus.level5')) {
                    return this.$t('trainingStatus.desc6')
                } else if (n == this.$t('trainingStatus.level6')) {
                    return this.$t('trainingStatus.desc7')
                } else if (n == this.$t('trainingStatus.level7')) {
                    return this.$t('trainingStatus.desc8')
                }
            }
        }
    }
</script>

<style scoped>

    #chart-box {
        height: 198px;
        width: 100%;
    }

    .legend-box {
        width: 100%;
        height: 56px;
        position: relative;
    }

    .legend-box-en {
        width: 100%;
        height: 98px;
        position: relative;
    }

    .legend-bar {
        position: absolute;
        width: 6px;
        height: 6px;
        border-radius: 50%;
    }

    .legend-bar1 {
        background-color: var(--chart-color-25);
        left: 28px;
        top: 6px;
    }

    .legend-bar2 {
        background-color: var(--chart-color-8);
        left: 106px;
        top: 6px;
    }

    .legend-bar3 {
        background-color: var(--chart-color-14);
        left: 196px;
        top: 6px;
    }

    .legend-bar4 {
        background-color: var(--chart-color-1);
        left: 288px;
        top: 6px;
    }

    .legend-bar5 {
        background-color: var(--chart-color-15);
        left: 28px;
        top: 32px;
    }

    .legend-bar6 {
        background-color: var(--chart-color-3);
        left: 106px;
        top: 32px;
    }

    .legend-bar7 {
        background-color: var(--chart-color-16);
        left: 196px;
        top: 32px;
    }

    .legend-bar8 {
        background-color: var(--chart-color-3);
        left: 288px;
        top: 32px;
    }

    .legend-bar11 {
        background-color: var(--chart-color-25);
        left: 30px;
        top: 4px;
    }

    .legend-bar22 {
        background-color: var(--chart-color-8);
        left: 190px;
        top: 4px;
    }

    .legend-bar33 {
        background-color: var(--chart-color-14);
        left: 30px;
        top: 30px;
    }

    .legend-bar44 {
        background-color: var(--chart-color-1);
        left: 190px;
        top: 30px;
    }

    .legend-bar55 {
        background-color: var(--chart-color-15);
        left: 30px;
        top: 56px;
    }

    .legend-bar66 {
        background-color: var(--chart-color-5);
        left: 190px;
        top: 56px;
    }

    .legend-bar77 {
        background-color: var(--chart-color-16);
        left: 30px;
        top: 82px;
    }

    .legend-bar88 {
        background-color: var(--chart-color-3);
        left: 190px;
        top: 82px;
    }

    .legend-text {
        position: absolute;
        font-size: 13px;
        color: var(--text-color-2);
    }

    .legend-text1 {
        top: 0;
        left: 41px;
    }

    .legend-text2 {
        top: 0;
        left: 119px;
    }

    .legend-text3 {
        top: 0;
        left: 209px;
    }

    .legend-text4 {
        top: 0;
        left: 301px;
    }

    .legend-text5 {
        top: 26px;
        left: 41px;
    }

    .legend-text6 {
        top: 26px;
        left: 119px;
    }

    .legend-text7 {
        top: 26px;
        left: 209px;
    }

    .legend-text8 {
        top: 26px;
        left: 301px;
    }

    .legend-text11 {
        top: 0;
        left: 45px;
    }

    .legend-text22 {
        top: 0;
        left: 205px;
    }

    .legend-text33 {
        top: 26px;
        left: 45px;
    }

    .legend-text44 {
        top: 26px;
        left: 205px;
    }

    .legend-text55 {
        top: 52px;
        left: 45px;
    }

    .legend-text66 {
        top: 52px;
        left: 205px;
    }

    .legend-text77 {
        top: 78px;
        left: 45px;
    }

    .legend-text88 {
        top: 78px;
        left: 205px;
    }

    .time-box {
        width: 180px;
    }
</style>



// WEBPACK FOOTER //
// src/views/status/13trainingStatus.vue